const Config = () => {
  return <>Config</>;
};
export default Config;
export const BASE_URL = process.env.REACT_APP_BASE_URL;

const auth = JSON.parse(localStorage.getItem("auth"));
const token = auth ? auth.access_token : null;

let globalVar = {
  url: BASE_URL,
  Token: token,
};

export const getGlobalVar = () => globalVar;
export const setGlobalVar = (value, USER) => {
  globalVar.Token = value;
  globalVar.USER = USER;
  localStorage.setItem("user", JSON.stringify(USER));
};
